"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Activity, Calendar, ChevronRight, Clock, MoreHorizontal, Users, CheckCircle2, AlertCircle } from "lucide-react";
const scheduleItems = [{
  id: 1,
  time: "08:00 AM",
  role: "Surgical Tech",
  name: "Sarah Jenkins",
  status: "Confirmed",
  isConfirmed: true
}, {
  id: 2,
  time: "09:30 AM",
  role: "Anesthesiologist",
  name: "Dr. Robert Smith",
  status: "Pending",
  isConfirmed: false
}, {
  id: 3,
  time: "11:00 AM",
  role: "OR Nurse",
  name: "Michael Torres",
  status: "Confirmed",
  isConfirmed: true
}, {
  id: 4,
  time: "01:15 PM",
  role: "Circulating Nurse",
  name: "Emily Chen",
  status: "In Progress",
  isConfirmed: true
}];
const dashboardStats = [{
  id: 1,
  label: "Active Staff",
  value: "124",
  icon: Users
}, {
  id: 2,
  label: "Coverage",
  value: "98%",
  icon: Activity
}, {
  id: 3,
  label: "Open Shifts",
  value: "3",
  icon: Calendar
}];
const platformFeatures = [{
  id: 1,
  text: "Digital coverage requests"
}, {
  id: 2,
  text: "Streamlined scheduling coordination"
}, {
  id: 3,
  text: "Electronic confirmations"
}, {
  id: 4,
  text: "Secure communication"
}, {
  id: 5,
  text: "Mobile-friendly experience"
}, {
  id: 6,
  text: "App-based access (where available)"
}];
export default function DigitalPlatform() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return;
}